__turbopack_context__.v({
  "back-button": "BWtUBq_back-button",
  "career-content": "BWtUBq_career-content",
  "career-detail": "BWtUBq_career-detail",
  "container": "BWtUBq_container",
});
